var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.msg)+" "),(_vm.additionalMsg)?_c('div',{attrs:{"color":"primary"}},[_vm._v(" "+_vm._s(_vm.additionalMsg)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }